import React from 'react';
import { useDonation } from '../context/DonationContext';
import DonationSetup from './DonationSetup';
import DonationWorkspace from './DonationWorkspace';

function DonationEntry({ onComplete }) {
  const { state } = useDonation();

  if (!state.currentDonation) {
    return <DonationSetup onSetup={() => {}} />;
  }

  return (
    <div className="animate-in fade-in duration-500">
      <DonationWorkspace onComplete={onComplete} />
    </div>
  );
}

export default DonationEntry;